module.exports = __webpack_public_path__ + "img/mac-download.857d2fea.png";